import type React from 'react'
import { cn } from '../../../shared/cn'

export function H1({ className, ...props }: React.ComponentPropsWithoutRef<'h1'>) {
  return (
    <h1
      {...props}
      className={cn('font-semibold text-2xl text-contentPrimary leading-8', className)}
    />
  )
}
